import { UseWpoktMintControllerReturnType } from './useWpoktMintController.types'

export const MINT_CONTROLLER_ADDRESS = '0x0d006D9e862B362180eb602e5973Fd1fdb6f78dd'

const notInitialized = () => {
    throw new Error('Contract not initialized yet.')
}

export const useWpoktMintControllerDefaultReturnType: UseWpoktMintControllerReturnType = {
    mintWpokt: notInitialized,
    isLoadingMint: true,
}

export const WpoktMintControllerAbi = [
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wPokt',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [],
        name: 'BelowMinThreshold',
        type: 'error',
    },
    {
        inputs: [],
        name: 'InvalidShortString',
        type: 'error',
    },
    {
        inputs: [],
        name: 'InvalidSignatureRatio',
        type: 'error',
    },
    {
        inputs: [],
        name: 'InvalidSignatures',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NonAdmin',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NonCopper',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NonZero',
        type: 'error',
    },
    {
        inputs: [],
        name: 'OverMintLimit',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'str',
                type: 'string',
            },
        ],
        name: 'StringTooLong',
        type: 'error',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'limit',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'lastMint',
                type: 'uint256',
            },
        ],
        name: 'CurrentMintLimit',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [],
        name: 'EIP712DomainChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'newLimit',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'newCooldown',
                type: 'uint256',
            },
        ],
        name: 'MintCooldownSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'validator',
                type: 'address',
            },
        ],
        name: 'NewValidator',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'validator',
                type: 'address',
            },
        ],
        name: 'RemovedValidator',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'ratio',
                type: 'uint256',
            },
        ],
        name: 'SignerThresholdSet',
        type: 'event',
    },
    {
        inputs: [],
        name: 'DEFAULT_ADMIN_ROLE',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'validator',
                type: 'address',
            },
        ],
        name: 'addValidator',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'currentMintLimit',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'eip712Domain',
        outputs: [
            {
                internalType: 'bytes1',
                name: 'fields',
                type: 'bytes1',
            },
            {
                internalType: 'string',
                name: 'name',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'version',
                type: 'string',
            },
            {
                internalType: 'uint256',
                name: 'chainId',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'verifyingContract',
                type: 'address',
            },
            {
                internalType: 'bytes32',
                name: 'salt',
                type: 'bytes32',
            },
            {
                internalType: 'uint256[]',
                name: 'extensions',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'lastMint',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'lastMintLimit',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'maxMintLimit',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'mintPerSecond',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'recipient',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'nonce',
                        type: 'uint256',
                    },
                ],
                internalType: 'struct MintController.MintData',
                name: 'data',
                type: 'tuple',
            },
            {
                internalType: 'bytes[]',
                name: 'signatures',
                type: 'bytes[]',
            },
        ],
        name: 'mintWrappedPocket',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'validator',
                type: 'address',
            },
        ],
        name: 'removeValidator',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'newLimit',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'newMintPerSecond',
                type: 'uint256',
            },
        ],
        name: 'setMintCooldown',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'signatureRatio',
                type: 'uint256',
            },
        ],
        name: 'setSignerThreshold',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'signerThreshold',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'validatorCount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'validators',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'wPokt',
        outputs: [
            {
                internalType: 'contract IWPokt',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];